import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Main from './Main';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router";

//
//
import Layout from './Layout.js';

//import Checkout from './checkout/CheckoutForm';
import CheckoutPage from './checkout/CheckoutSession';
import SuccessPage from "./checkout/SuccessPage";
import ConfirmPage from './checkout/ConfirmForm';
import CompletePage from './checkout/CompletePage';

//const root = ReactDOM.createRoot(
//  document.getElementById('root') as HTMLElement
//);


//test key
//
/*
const stripePromise = loadStripe("pk_test_51Jhkp3HnuB8EhwWC0xVIcdzc2IWkQjEzkTKtuJIvQxpgG7DxOumgVbzYpS6AUvzVFIzxHbxo6u2vXLzv7IDB6c2k00W7skyO93");

const options = {
	mode: 'payment',
	currency: 'cad',
	amount: 3995
}

*/

const root = ReactDOM.createRoot(document.getElementById('root'));

//live key
//const stripePromise = loadStripe("pk_live_51Jhkp3HnuB8EhwWC1VMYTSzzKnXXIa5fqBnz3VYq0H07l6EnckA3YkFBNEfxP3eAwU5rAufxhOQIM30XKstEit8a00Ku94vGGy");

root.render(
<React.StrictMode>
		<BrowserRouter> 
		 	<Routes>
		  	 <Route path='/' element={<Layout />}>
		   	 <Route index element={<Main />} />
		   	 <Route path='/checkout' element={<CheckoutPage />} />
           	 <Route path='/success' element={<SuccessPage />} />
           	 <Route path='/confirm' element={<ConfirmPage />} />
           	 <Route path='/complete' element={<CompletePage />} />
		  	</Route>
		 	</Routes>
		</BrowserRouter>
</ React.StrictMode>
);

//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
